<template>
  <div v-show="!horizontalScrollable || (horizontalScrollable && (vehicleCountData == null || vehicleCountData.total > 0))">
    <div
      v-if="
        title.length > 0 ||
          (horizontalScrollable && !hideHorizontalScrollableButtons)
      "
      class="flex items-center justify-between no-wrap q-mb-md"
    >
      <div class="flex items-center no-wrap ellipsis">
        <div
            :class="{ 'flex items-center no-wrap': windowWidth > 1025 }"
            class="ellipsis"
        >
          <h5
            v-if="title.length > 0"
            class="section-title ellipsis q-mb-none q-mr-md"
          >
            {{ title }}
          </h5>
          <div
            v-if="showVehicleCount && vehicleCountData"
            class="flex items-center no-wrap ellipsis"
            style="margin-bottom: -2px"
            :style="[windowWidth <= 1025 ? { 'margin-top': '2px' } : {}]"
          >
            <div class="text-text-light text-weight-medium q-mr-xs" :class="{ '--text-sm': windowWidth <= 1025 }">
              ({{ formatNumber(vehicleCountData.total, true, 1) }} Vehicles)
            </div>
            <div
              v-if="vehicleCountData.percentChange && parseInt(vehicleCountData.percentChange) !== 0"
              class="--text-sm text-weight-medium"
            >
              <PercentChangeIndicator
                :percent-change="vehicleCountData.percentChange"
                append-text="since last visit"
              />
            </div>
          </div>
        </div>

        <slot name="title-append" />
      </div>

      <q-space />

      <div
        v-if="
          horizontalScrollable &&
            !hideHorizontalScrollableButtons &&
            windowWidth > 1025
        "
        class="flex items-center no-wrap"
      >
        <q-btn
          round
          dense
          color="background-light"
          icon="sym_r_keyboard_arrow_left"
          class="--bordered --shadow__bottom q-mr-sm"
          @click="
            () => {
              triggerHorizontalScrollableScroll(id, 'left');
            }
          "
        />
        <q-btn
          round
          dense
          color="background-light"
          icon="sym_r_keyboard_arrow_right"
          class="--bordered --shadow__bottom"
          @click="
            () => {
              triggerHorizontalScrollableScroll(id, 'right');
            }
          "
        />
      </div>

      <q-btn
          v-if="showViewAll && listings.length > 0"
          color="secondary"
          no-caps
          rounded
          class="q-ml-sm --bordered --shadow__bottom q-ml-md"
          @click="$emit('view-all-click')"
          style="padding: 4px 12px !important; min-height: auto !important;"
      >
        <div class="flex items-center no-wrap --text-sm">
          <div>View All</div>
          <q-icon name="sym_r_chevron_right" size="20px" class="q-ml-xs" style="margin-right: -4px; margin-top: -1px"/>
        </div>
      </q-btn>
    </div>
    <div style="margin-top: -8px; margin-bottom: 6px;">
      <slot name="title-below" />
    </div>
    <component
      v-bind:is="horizontalScrollable ? HorizontalScrollable : ResponsiveGrid"
      v-bind="{
        ...(responsive && !horizontalScrollable
          ? { 'max-columns': maxResponsiveColumns }
          : {})
      }"
      class="vehicle-listings"
      :key="id"
      :ref="id"
    >
      <template v-if="listings.length > 0">
        <VehicleCard
          v-for="(vehicle, i) in listings"
          :key="i + '_vehicleListing'"
          :vehicle="vehicle"
        />
      </template>
      <template v-if="!fetching && listings.length < 4">
        <div v-for="i in 3" :key="i + '_vehicleListingPlaceholder'" />
      </template>
      <template v-if="fetching">
        <VehicleCardPlaceholder
          v-for="j in 20"
          :key="j + '_vehicleListingLoader'"
        />
      </template>
      <InfiniteScrollObserver
        v-if="!disableInfiniteScroll && listings.length > 0"
        @intersect="addToQueue(() => emitEvent())"
        :horizontal-scrollable="horizontalScrollable"
        :custom-root-margin="infiniteScrollCustomMargin"
      />
    </component>
  </div>
</template>

<script>
import HorizontalScrollable from "@/components/UI/HorizontalScrollable.vue";
import ResponsiveGrid from "@/components/UI/ResponsiveGrid.vue";
import InfiniteScrollObserver from "@/components/UI/InfiniteScrollObserver.vue";
import VehicleCardPlaceholder from "@/components/VehicleListings/VehicleCardPlaceholder.vue";
import VehicleCard from "@/components/VehicleListings/VehicleCard.vue";
import PercentChangeIndicator from "@/components/UI/PercentChangeIndicator.vue";

export default {
  name: "ListingsContainer",
  components: {
    PercentChangeIndicator,
    VehicleCard,
    VehicleCardPlaceholder,
    InfiniteScrollObserver,
    HorizontalScrollable,
    ResponsiveGrid
  },
  props: {
    listings: {
      type: Array,
      required: true
    },
    fetching: {
      type: Boolean,
      default: false
    },
    showNoListings: {
      type: Boolean,
      default: false
    },
    customNoListingsText: {
      type: String,
      default: "No listings found."
    },
    horizontalScrollable: {
      type: Boolean,
      default: false
    },
    hideHorizontalScrollableButtons: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: true
    },
    maxResponsiveColumns: {
      type: Number,
      default: 4
    },
    disableInfiniteScroll: {
      type: Boolean,
      default: false
    },
    infiniteScrollCustomMargin: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    showVehicleCount: {
      type: Boolean,
      default: false
    },
    vehicleCountData: {
      type: Object,
      default: null
      // Expected format:
      // {
      //   total: 123,
      //   percentChange: 10.5,
      //   showCountSinceLastVisit: true
      // }
    },
    showViewAll: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      eventQueue: [],
      isProcessingQueue: false,
      id: "listingsContainer_" + Math.random() * 10000
    };
  },
  computed: {
    ResponsiveGrid() {
      return ResponsiveGrid;
    },
    HorizontalScrollable() {
      return HorizontalScrollable;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    emitEvent() {
      this.$emit("fetch-listings");
    },
    addToQueue(event) {
      // Make sure we dont send the same event twice
      if (this.eventQueue.length === 0) {
        this.eventQueue.push(event);
        this.processQueue();
      }
    },
    processQueue() {
      if (this.eventQueue.length > 0 && !this.isProcessingQueue) {
        this.isProcessingQueue = true;
        const event = this.eventQueue.shift();
        event();
        setTimeout(() => {
          this.isProcessingQueue = false;
          this.processQueue();
        }, 750);
      }
    },
    triggerHorizontalScrollableScroll(refId, direction) {
      this.$refs[refId].triggerManualScroll(direction);
    }
  }
};
</script>
